import { Wording } from '@/types';

export const FITNESS_WORDING_LV: Wording = {
  components_header_media_content: 'Treniņi',
  components_header_media_1: 'Vīriešiem',
  components_header_media_2: 'Sievietēm',
  components_header_text1: 'Receptes',
  components_header_text2: 'Emuārs',
  components_header_members: 'Biedri',
  hero_text: 'Uzturiet savu ķermeni formā un stipru',
  hero_button_text: 'Sāciet savu fitnesa ceļojumu',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text:
    'Visi veselīgam dzīvesveidam nepieciešamie resursi',
  components_ressources_span_text:
    'Barojiet savu labsajūtu: izmantojiet daudzus resursus holistiskai veselībai un pilnvērtīgam dzīvesveidam, tostarp ekspertu norādījumus par fizisko sagatavotību, uzturu un ilgtspējīgu dzīvesveidu.',
  components_ressources_card_1_title: 'Motivācija',
  components_ressources_card_1_text:
    'Īsi motivācijas uzliesmojumi noturīgiem vingrošanas paradumiem.',
  components_ressources_card_2_title: 'Diēta',
  components_ressources_card_2_text:
    'Gudra uztura padomi veselīgākam un stiprākam.',
  components_ressources_link: 'Skatieties video',
  components_notes_and_google_title_1: 'Fitnesa treniņi',
  components_notes_and_google_title_2: 'Regulāra rutīna',
  components_notes_and_google_title_3: 'Diētas uzturēšana',
  components_review_google_text: 'Pārskats Google tīklā',
  media_content_section_title: 'TRENIŅI',
  media_content_section_subheader_text: 'Mūsu video',
  text_media_1: 'Vīrieši',
  text_media_2: 'Sievietes',
  media_content_section_button_more: 'Vairāk video',
  text2_section_title: 'BLOGS',
  text2_section_subheader_text: 'Raksti un ziņas',
  text2_section_button_more: 'Vairāk rakstu',
  components_text1_section_title: 'RECEPTES',
  components_text1_subheader_text: 'Veselīgs uzturs aktīvai dzīvei',
  components_text1_span_text:
    'Ēdienu gatavošana: izpētiet garšīgu fitnesa pasauli, izmantojot mūsu ātrās un ar uzturvielām bagātās receptes.',
  components_text1_card_1_title: 'Sāciet savu dienu',
  components_text1_card_1_text:
    'Sāciet savus rītus tieši ar uzturvielām bagātām, olbaltumvielām bagātām brokastīm.',
  components_text1_card_3_title: 'Jaudīgas pusdienas',
  components_text1_card_3_text:
    'Atklājiet gardas un ērtas pusdienu receptes, kas paredzētas jūsu aktīvajam dzīvesveidam. No krāsainiem salātiem līdz olbaltumvielām bagātiem iesaiņojumiem – šīs receptes saglabās jūsu enerģiju un koncentrēšanos.',
  components_text1_card_2_title: 'Vakariņas atveseļošanai',
  components_text1_card_2_text:
    'Izpētiet dažādas liesās olbaltumvielas, veselus graudus un dinamiskus dārzeņus, lai nobeigtu savu dienu.',
  components_text1_link: 'Skatīt visas receptes',
  components_footer_text:
    'Palieliniet savu spēku, uzliesmojiet savu kaislību: jūsu sporta zāle, jūsu pārvērtības.',
  components_footer_info: 'Informācija',
  components_footer_registration_number: 'Reģistrācijas numurs',
  components_footer_legal: 'Juridisks',
  components_footer_terms: 'Noteikumi un nosacījumi',
  components_footer_privacy: 'Privātuma politika',
  button_load_more: 'Ielādēt vairāk',
  page_media_1_content_hero_text: 'Vīriešu treniņi',
  page_media_content_menu_all: 'Visi',
  page_media_content_menu_biceps: 'Bicepss',
  page_media_content_menu_triceps: 'Tricepss',
  page_media_content_menu_back: 'Atpakaļ',
  page_media_content_menu_chest: 'Krūtis',
  page_media_content_menu_legs: 'Kājas',
  page_media_content_menu_shoulders: 'Pleci',
  page_media_content_menu_abdominals: 'Vēders',
  page_media_2_content_hero_text: 'Sieviešu treniņi',
  page_text1_hero_text: 'Receptes',
  page_text1_section_title: 'Uzturs',
  page_text1_subheader_text: 'Receptes',
  page_text2_hero_text: 'Mūsu emuārs',
  page_text2_section_title: 'Emuārs',
  page_text2_subheader_text: 'Raksti un ziņas',
  enter_email_title: 'Lūdzu, ievadiet savu e-pastu, lai turpinātu',
  enter_email_placeholder_email: 'E-pasts',
  enter_email_button_enter: 'Ievadiet',
  components_login_success_text: 'Pieteikšanās veiksmīga!',
  components_card_link_media_content: 'Skatieties tūlīt',
  components_card_link_text1_content: 'Skatīt recepti',
  components_card_link_text2_content: 'Skatīt rakstu',
  france: 'Francija',
  cyprus: 'Kipra',
};
